module.exports = __webpack_public_path__ + "static/media/cod-hero.464eb10c.jpg";